import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";
import { activity } from "../../../lib/selectors/WritingSelectors";
import _, { all } from "underscore";

var ReactTooltip = require("react-tooltip");

var CurrentUser = require("lib/account/CurrentUser");
var StudentMetrics = require("lib/data/StudentMetrics");
var DataRouting = require("lib/routing/DataRouting");
var Formats = require("lib/academic/Formats");
var Skillsets = require("lib/academic/Skillsets");
var UIActions = require("lib/actions/UIActions");

var Glyphicon = require("components/utility/icons/Glyphicon");
var NoActivityBlock = require("components/data/subjects/shared/NoActivityBlock");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var ButtonDropdown = require("components/utility/ButtonDropdown");
var ProgressBar = require("components/utility/ProgressBar");
var StudentAvatar = require("components/avatars/StudentAvatar");
var StudentListDisplay = require("components/org/student_lists/StudentListDisplay");

var WritingSelectors = require("lib/selectors/WritingSelectors");
var WritingActions = require("lib/actions/WritingActions");
var ReadingActions = require("lib/actions/ReadingActions");
var ReadingSelectors = require("lib/selectors/ReadingSelectors");
var RosterSelectors = require("lib/selectors/RosterSelectors");

require("writing/activities/all_student_activities_table.scss");

function propsToConditions(props) {
  var conditions = _.pick(props,
    "startDate", "endDate", "textID", "userIDs", "dueDate"
  );

  return conditions;
}

@connect(
  (state, props) => ({
    tasks: WritingSelectors.tasks({ state, conditions: propsToConditions(props)}),
    students: RosterSelectors.students({ state })
  }),
  (dispatch, props) => ({
    populateData: () => {
      // TODO: standardize FE requests
      // if the dataset of students is large, send multiple requests
      if ($wr.isLargeRequest(props.userIDs)) {
        var conditions = _.pick(props, "startDate", "endDate", "textID", "dueDate")
        var actionFunction = WritingActions.fetchTasks
        var options = { embeds: ['task.task_items'], cache: true }
        return new Promise(function (resolve, reject) {
          $wr.handleLargeRequest(dispatch, props.userIDs, conditions, actionFunction, options, (results) => {
            resolve(results);
          })
        }).catch(() => console.log("Tasks failed to load"))
      } else {
        return dispatch(WritingActions.fetchTasks({
          embeds: ['task.task_items'],
          conditions: propsToConditions(props),
          cache: true
        }))
      }
    },
    fetchBook: (textID) => {
      dispatch(ReadingActions.batchFetchBook({ id: textID }))
    },
    toggleExpandedResponse: (responseID) => {
      dispatch(UIActions.toggleExpandedResponse({ responseID: responseID, expanded: true }));
    }
  })
)
@providePopulateData()
class AllStudentActivitiesTable extends React.Component {
  constructor(props) {
    super();
    autobind(this);

    this.state = { orderBy: STUDENT_NAME_ORDER };
  }

  changeSortBy(orderBy) {
    this.setState({ orderBy });
  }

  handleActivityClick(e) {
    if (e.currentTarget.getAttribute('data-response-id')) {
      this.props.toggleExpandedResponse(e.currentTarget.getAttribute('data-response-id'))
    }
  }

  dateFormat(date) {
    let d = new Date(date);
    let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    let mo = new Intl.DateTimeFormat('en', { month: 'numeric' }).format(d);
    let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);

    return `${da}/${mo}/${ye}`
  }

  renderSortControl() {
    var orderOptionText = (op) => {
      if (STUDENT_NAME_ORDER === op) {
        return "Student Name";
      } else if (LAST_ACTIVE === op) {
        return "Last Activity";
      } else if (TEACHER_PICKS_COMPLETE === op) {
        return "Teacher Picks Completed";
      } else if (EXERCISE_COMPLETE === op) {
        return "Exercises Completed";
      } else {
        return StudentMetrics.getLabel(op);
      }
    }

    var renderOption = (op) => {
      return (
        <ButtonDropdownOption key={op} className=""
          text={orderOptionText(op)}
          onClick={this.changeSortBy.bind(this, op)}>
        </ButtonDropdownOption>
      );
    }

    var orderOptions = [];

    orderOptions.push(renderOption(STUDENT_NAME_ORDER));
    orderOptions.push(renderOption(LAST_ACTIVE));
    orderOptions.push(renderOption(TEACHER_PICKS_COMPLETE));
    orderOptions.push(renderOption(EXERCISE_COMPLETE));

    if (this.props.showGoals) {
      _.each(this.props.expectationMetrics, (metric) => {
        orderOptions.push(renderOption(metric));
      });

    } else {
      _.each(this.props.userMetricsColumns, (metric) => {
        orderOptions.push(renderOption(metric));
      });
    }

    var displayText = orderOptionText(this.state.orderBy);

    return (
      <ButtonDropdown dropdownDisplay="link" text={displayText}>
        { orderOptions}
      </ButtonDropdown>
    );
  }

  renderTableHeaders(rows) {
    if (rows.length) {
      var sortLink = (
        <div className="infoSection studentNameHeader sortControlCell hideOnPrint">
          Sort By: { this.renderSortControl()}
        </div>
      )
      var activitiesHeader = (
        <div className="statSection">
          <div className="columnHeaderText">Exercises</div>
        </div>
      )
      var teacherPicksHeader = (
        <div className="statSection">
          <div className="columnHeaderText">Teacher Picks</div>
        </div>
      )

      return (
        <div className="studentRow headerRow">
          <div className="rowContent">
            {sortLink}
            {activitiesHeader}
            {teacherPicksHeader}
          </div>
        </div>
      );
    } else {
      return '';
    }
  };
  
  isComplete(exercise) {
    return ('completed_at' in exercise && exercise.completed_at !== null) || ('draft' in exercise && exercise.daft === true) ? true : false 
  }
  // returns all task items for a user
  getTaskItems(userID) {
    var taskItems = _.pluck(_.where(this.props.tasks, { user_id: userID }), 'task_items')
    return [...new Set(taskItems.flat())];
  }
  // retuns all tasks and task items for a user
  getAllTasks(userID) {
    var standAloneExercises = _.where(this.props.tasks, { subject_type: 'exercise', user_id: userID })
    var taskItemExercises = _.where(this.getTaskItems(userID), { subject_type: 'exercise', user_id: userID })
    return taskItemExercises.concat(standAloneExercises)
  }
  // sort user tables
  sortUserIDs() {
    var orderBy = this.state.orderBy;
    if (orderBy == LAST_ACTIVE) {
      var students =  _.sortBy(this.props.students, (student) => {
        return student.last_active || "1970-01-01";
      }).reverse()
    } else if (orderBy == EXERCISE_COMPLETE) {
      var students = _.sortBy(this.props.students, (student) => {
        var allExercises = this.getAllTasks(student.id)
        return _.size(_.filter(allExercises, (exercise) => { return this.isComplete(exercise) }))
      }).reverse()
    } else if (orderBy == TEACHER_PICKS_COMPLETE) {
      var students = _.sortBy(this.props.students, (student) => {
        return _.size(_.where(this.getTaskItems(student.id), { draft: false }));
      }).reverse()
    }
    else {
      var students = $wr.sortByName(this.props.students, "flexName");
    }
    return _.pluck(students, 'id')
  }
  // renders no activities block if there are students with no assigned activities
  renderNoActivitiesBlock(studentsWithoutExercises) {
    return studentsWithoutExercises.length ? <NoActivityBlock userIDs={studentsWithoutExercises} contentType="Activities" /> : ''
  }

  render() {
    var studentsWithoutExercises = [];
    var rows = _.map(this.sortUserIDs(), (userID) => {
      // combine array of arrays
      var taskItems = this.getTaskItems(userID)
      var allExercises = this.getAllTasks(userID)

      var assignedExercises = _.size(allExercises)
      var completedExercises = _.size(_.filter(allExercises, (exercise) => { return this.isComplete(exercise) }))
      
      if (taskItems.length || allExercises.length) {
        var assignedTaskItems = taskItems.length;
        var completedTaskItems = _.size(_.where(taskItems, { draft: false }));

        var studentName = _.findWhere(this.props.students, { id: userID }).display_name || ''

        return (
          <div className="studentRow" key={userID}>
            <div className="rowContent">
              <div className="infoSection dataCell">
                <div className="avatarBox hideOnPrint">
                  <StudentAvatar studentID={userID} maxWidth={ 30 } />
                </div>
                <div className="infoSection studentName ellipsisText">
                  {studentName}
                  <StudentListDisplay studentID={userID} />
                </div>
              </div>
              <div className="statSection dataCell">
                <div>
                  <span>
                    {completedExercises}/{assignedExercises}
                  </span>
                </div>
                <ProgressBar current={completedExercises} total={assignedExercises} />
              </div>
              <div className="statSection dataCell">
                <div>
                  <span>
                    {completedTaskItems}/{assignedTaskItems}
                  </span>
                </div>
                <ProgressBar current={completedTaskItems} total={assignedTaskItems} />
              </div>
            </div>
          </div>
        );
      } else {
        studentsWithoutExercises.push(userID)
      }
    })
    
    rows = _.filter(rows, (row) => row !== undefined)

    return (
      <div className="allStudentActivitiesTable">
        {this.renderTableHeaders(rows)}
        {rows}
        {this.renderNoActivitiesBlock(studentsWithoutExercises)}
      </div>
    );
  }
}

var LAST_ACTIVE = "last-active";
var STUDENT_NAME_ORDER = "student-name";
var TEACHER_PICKS_COMPLETE = "teacher-picks-complete";
var EXERCISE_COMPLETE = "exercise-complete";

AllStudentActivitiesTable.WrappedComponent.propTypes = StrictPropTypes({
  // userID of the student for this table
  startDate: PropTypes.string,
  userIDs: PropTypes.array,
  endDate: PropTypes.string,
  textVariety: PropTypes.string,
  textID: PropTypes.string,
  showFullData: PropTypes.bool,
  // List of activities
  activities: PropTypes.array,
  students: PropTypes.array,
  tasks: PropTypes.array,
  activityTasks: PropTypes.array,
  books: PropTypes.array,
  // List of responses
  responses: PropTypes.array,
  // Data from @connect
  loading: PropTypes.bool,
  // Handlers from @connect
  populateData: PropTypes.func,
  fetchBook: PropTypes.func,
  toggleExpandedResponse: PropTypes.func,
});

module.exports = AllStudentActivitiesTable


// WEBPACK FOOTER //
// ./modules/components/writing/activities/AllStudentActivitiesTable.js